import { chunk } from 'lodash';

import { getFormValuesObject } from './getFormValuesObject';
import { getRowBooleanOperator, getRowFieldQualifierValue } from './getRow';
import { parseMaskedFieldQualifierValue } from './parseMaskedFieldQualifierValue';
import {
  BooleanOperator,
  booleanOperatorRegex,
  FormValues,
} from '../constants';

const getFormValuesWithInvalidQuery = (query: string): FormValues => {
  const formValues = getFormValuesObject();

  formValues[0].value = query;
  formValues[0].isInvalid = true;

  return formValues;
};

export const createBooleanOperatorQuery = (operator: BooleanOperator) =>
  ` ${operator.toUpperCase()} `;
export const andBooleanOperator = createBooleanOperatorQuery(
  BooleanOperator.and
);

export const parseMaskedAdvancedSearchQuery = ({
  query,
  isConsortiaMode,
}: {
  query: string;
  isConsortiaMode?: boolean;
}): FormValues => {
  const regex = new RegExp(
    `${booleanOperatorRegex}(?=\\w+(?: \\w+ ${
      isConsortiaMode ? '|=' : ''
    })".*")`,
    'g'
  );
  const [firstRow, ...rowsWithBooleanOperator] = query.split(regex);
  const rowValues = [
    [andBooleanOperator, firstRow],
    ...chunk(rowsWithBooleanOperator, 2),
  ].map(row => [getRowBooleanOperator(row), getRowFieldQualifierValue(row)]);

  try {
    return rowValues.reduce((values: FormValues, row, index) => {
      const fieldQualifierValue = getRowFieldQualifierValue(row);

      values[index] = {
        ...parseMaskedFieldQualifierValue({
          fieldQualifierValue,
          isConsortiaMode,
        }),
        ...(index > 0 && {
          booleanOperator: getRowBooleanOperator(row) as BooleanOperator,
        }),
      };

      return values;
    }, getFormValuesObject());
  } catch (error) {
    return getFormValuesWithInvalidQuery(query);
  }
};
